/**
 * Format a Date object as YYYY-MM-DD (local time, no UTC shift).
 */
export function toLocalDate(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}

// Alias used in some files
export const toLocalDateString = toLocalDate;

/**
 * Format a date string/object for display (e.g. "5 Jun 2026").
 */
export function fmtDisplay(d, opts = {}) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric', ...opts,
  });
}
